(async () => {
  const el = document.getElementById('rate-fraud-free')

  if (!el) {
    return
  }

  const { default: clientRender } = (await import(/* webpackMode: 'eager' */ 'vue-compiler/clientRender'))

  const components = [
    {
      el,
      componentImport: () => import(/* webpackMode: 'eager' */ 'src/pages/info/rate-fraud-free/index.vue'),
    },
  ]

  await clientRender({ components })
})()
